<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-lg-6">
                <b-card>
                    <div slot="header">
                        <i :class="[isEditing ? 'fa-edit' : 'fa-plus-square-o', 'fa']"></i><strong> Account</strong>
                        <small>
                            <span v-if="isEditing">wijzigen</span>
                            <span v-else>toevoegen</span>
                        </small>
                    </div>
                    <form @submit.prevent="saveItem">
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-form-label" for="voornaam">Voornaam <sup>*</sup></label>
                                <input type="text" v-model="model.voornaam" id="voornaam" name="voornaam" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('voornaam') }" />
                                <span class="small text-danger" v-show="errors.has('voornaam')">Voornaam is verplicht</span>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-form-label" for="naam">Naam <sup>*</sup></label>
                                <input type="text" v-model="model.naam" id="naam" name="naam" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('naam') }" />
                                <span class="small text-danger" v-show="errors.has('naam')">Naam is verplicht</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-form-label" for="email">E-mail <sup>*</sup></label>
                                <input type="text" @keyup="checkemail" v-model="model.email" id="email" name="email" v-validate="'required|email'" :class="{'form-control': true, 'is-invalid': (errors.has('email') || isErrorEmail) }" />
                                <span class="small text-danger" v-show="errors.has('email')">Ongeldig e-mailadres</span>
                                <span class="small text-danger" v-show="(isErrorEmail && !errors.has('email'))">E-mailadres bestaat reeds</span>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-form-label" for="tel">Telefoonnummer</label>
                                <input type="text" v-model="model.tel" id="tel" name="tel" class="form-control" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label class="col-form-label" for="typeuser">Type <sup>*</sup></label>
                                <select type="text" v-model="model.typeuser_id" id="typeuser" name="typeuser" v-validate="'required'" :class="{'form-control': true, 'is-invalid': errors.has('typeuser') }" >
                                    <template v-for="typeuser in typeusers">
                                        <option :value="typeuser.id" :selected="typeuser.id == (model.typeuser && model.typeuser_id)">{{typeuser.naam}}</option>
                                    </template>
                                </select>
                                <span class="small text-danger" v-show="errors.has('typeuser')">Kies een type</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-form-label">Actief van <sup>*</sup></label>
                                <input type="date" class="unstyled" v-model="model.begindatum" name="begindatum" id="begindatum" ref="begindatum" />
                                <span v-show="!model.begindatum" class="small text-danger">Kies een begindatum</span>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="col-form-label">tot <sup>*</sup></label>
                                <input type="date" class="unstyled" v-model="model.einddatum" name="einddatum" id="einddatum" ref="einddatum" />
                                <span v-show="!model.einddatum" class="small text-danger">Kies een einddatum</span>
                            </div>
                        </div>
                    </div>
                    <div slot="footer">
                        <b-button type="submit" variant="primary">
                            <span>Opslaan</span>
                        </b-button>
                        <b-button type="button" @click="back" variant="secondary">Annuleren</b-button>
                    </div>
                    </form>
                </b-card>
            </div>
            <div class="col-lg-6">
                <b-card>
                    <div slot="header">
                        <i class='fa fa-align-justify'></i><strong> Bedrijven</strong>
                    </div>
                    <form @submit.prevent="saveItem">
                        <template v-for="(tuinderbedrijf, index) in model.tuinderbedrijf_n">
                            <div class="row">
                                <div class="col-sm-12">
                                    <b-form-fieldset>
                                        <b-input-group>
                                            <select type="text" v-model="tuinderbedrijf.bedrijf_id" :id="'bedrijfid' + index" name="bedrijfid" class="form-control" >
                                                <template v-for="bedrijf in bedrijven">
                                                    <option :value="bedrijf.id" :selected="bedrijf.id == tuinderbedrijf.bedrijf_id">{{bedrijf.naam}}</option>
                                                </template>
                                            </select>
                                            <!-- Attach Right button -->
                                            <b-input-group-button slot="right">
                                                <b-button @click="verwijderBedrijf(index)" variant="primary"><i class='fa fa-trash'></i></b-button>
                                            </b-input-group-button>
                                        </b-input-group>
                                    </b-form-fieldset>
                                </div>
                            </div>
                        </template>
                        <div slot="footer">
                            <b-button variant="outline-primary" @click="addBedrijf">
                                <span>Bedrijf toevoegen</span>
                            </b-button>
                        </div>
                    </form>
                </b-card>
            </div>
        </div>
        <div style="height: 17em"></div>
    </div>
</template>

<script>
    import api from '../../api/account';

    export default {
        name: 'Form',
        props: ['model', 'typeusers', 'bedrijven', 'isEditing'],
        data () {
            return {
                isError: false,
                isErrorEmail: false,
            };
        },
        methods: {
            validEmail(mail)
            {
                if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail))
                {
                    return true;
                }
                return false;
            },
            checkemail () {
                if (this.validEmail(this.model.email)) {
                    api.isValidEmail(this.model.id, this.model.email).then((response) => {
                        this.isErrorEmail = (response.data === 'false');
                    });
                }
            },
            saveItem () {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.$emit('save-item', this.model);
                    }
                });
            },
            addBedrijf () {
                this.model.tuinderbedrijf_n.push({ user_id: this.model.id,
                    bedrijf_id: this.bedrijven[0].id });
            },
            verwijderBedrijf (i) {
                this.model.tuinderbedrijf_n.splice(i, 1);
            },
            back () {
                this.$router.go(-1);
            },
        },
        components: {
        },
    };
</script>

<style>

    input, select {
        padding: .55em .5em;
        font-size: 100%;
        border: 1px solid #ccc;
        width: 100%
    }

    .unstyled::-webkit-outer-spin-button, /* Removes arrows */
    .unstyled::-webkit-inner-spin-button, /* Removes arrows */
    .unstyled::-webkit-clear-button { /* Removes blue cross */
      -webkit-appearance: none;
      margin: 0;
    }

</style>



// WEBPACK FOOTER //
// src/pages/account/Form.vue